var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVafoodBevearge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    d: "M4.228 4.667a2.195 2.195 0 0 0-2.189 2.196.447.447 0 0 0 .894 0 1.3 1.3 0 0 1 1.295-1.302.447.447 0 0 0 0-.894Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    d: "M11.553 8.993h-.281v-2.13a3.5 3.5 0 0 0-3.5-3.499h-.461v-.318a.938.938 0 0 0-.946-.933h-.73a.938.938 0 0 0-.945.933v.318h-.462a3.5 3.5 0 0 0-3.5 3.5v2.13H.447a.447.447 0 0 0 0 .893h11.106a.447.447 0 0 0 0-.894Zm-5.97-5.947c0-.027.025-.04.052-.04h.73c.027 0 .052.013.052.04v.318h-.834v-.318Zm4.795 5.947H1.622v-2.13a2.605 2.605 0 0 1 2.606-2.605h3.544a2.605 2.605 0 0 1 2.606 2.605v2.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVafoodBevearge);
export default __webpack_public_path__ + "static/media/vafood-bevearge.e52365ba2c5e93742690d265cc914941.svg";
export { ForwardRef as ReactComponent };